import { PopupButton } from 'react-calendly';

export default function Calendly({ className }) {
  return (
    <div className="cal_div">
      <PopupButton
        url="https://calendly.com/slotit"
        rootElement={document.getElementById('__next')}
        text="Book a demo"
        className={className}
      />
    </div>
  );
}
